// extracted by mini-css-extract-plugin
module.exports = {"TaskList":"TaskList_TaskList__3_rB3"};